var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckOutlined, PlusOutlined } from '@ant-design/icons';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { Prescription, PrescriptionItem } from 'models';
import { useState } from 'react';
import NewPrescriptionItem from './NewPrescriptionItem';
import './style.css';
var initialsFromName = function (name) {
    if (!name)
        return '??';
    var parts = name.trim().split(/\s+/).filter(Boolean);
    if (!parts.length)
        return '??';
    if (parts.length === 1)
        return parts[0].slice(0, 2).toUpperCase();
    return "".concat(parts[0][0]).concat(parts[parts.length - 1][0]).toUpperCase();
};
var hasMedicine = function (item) { var _a; return Boolean((_a = item.getMedicineName()) === null || _a === void 0 ? void 0 : _a.trim()); };
var hasDescription = function (item) { var _a; return Boolean((_a = item.getDescription()) === null || _a === void 0 ? void 0 : _a.trim()); };
var isComplete = function (item) {
    return hasMedicine(item) && hasDescription(item);
};
var isEmpty = function (item) {
    return !hasMedicine(item) && !hasDescription(item);
};
var NewPrescription = function (props) {
    var prescription = useState(new Prescription())[0];
    var _a = useState([
        new PrescriptionItem()
    ]), prescriptionItems = _a[0], setPrescriptionItems = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var ensureTrailingEmptyCard = function (items) {
        var last = items[items.length - 1];
        if (last && isComplete(last)) {
            return __spreadArray(__spreadArray([], items, true), [new PrescriptionItem()], false);
        }
        return items;
    };
    var addPrescriptionItem = function () {
        setPrescriptionItems(function (current) {
            var last = current[current.length - 1];
            if (last && isEmpty(last))
                return current;
            if (last && !isComplete(last))
                return current;
            return __spreadArray(__spreadArray([], current, true), [new PrescriptionItem()], false);
        });
    };
    var onItemFieldsChange = function () {
        setError(null);
        setPrescriptionItems(function (current) { return ensureTrailingEmptyCard(current); });
    };
    var removePrescriptionItem = function (index) {
        setPrescriptionItems(function (current) {
            if (current.length <= 1) {
                return [new PrescriptionItem()];
            }
            var next = current.filter(function (_, i) { return i !== index; });
            return next.length ? next : [new PrescriptionItem()];
        });
    };
    var submit = function (event) {
        event.preventDefault();
        // Drop trailing empty cards the doctor never used.
        var items = __spreadArray([], prescriptionItems, true);
        while (items.length > 1 && isEmpty(items[items.length - 1])) {
            items = items.slice(0, -1);
        }
        // Also drop a single fully empty card if that's all that remains after trim.
        if (items.length === 1 && isEmpty(items[0])) {
            items = [];
        }
        if (!items.length) {
            setError(props.translate('prescriptions.form.errors.medicine'));
            return;
        }
        var incomplete = items.find(function (item) { return !isComplete(item); });
        if (incomplete) {
            if (!hasMedicine(incomplete)) {
                setError(props.translate('prescriptions.form.errors.medicine'));
            }
            else {
                setError(props.translate('prescriptions.form.errors.description'));
            }
            return;
        }
        setError(null);
        prescription.setPrescriptionItems(items);
        props.createPrescription(prescription);
        props.setShowPrescriptionForm(false);
    };
    var cancel = function () { return props.setShowPrescriptionForm(false); };
    var showContext = Boolean(props.patientName || props.appointmentId);
    return (_jsxs("form", { className: "rx-form", onSubmit: submit, noValidate: true, children: [showContext && (_jsxs("div", { className: "rx-form__context", children: [_jsxs("div", { className: "rx-form__context-main", children: [_jsx("div", { className: "rx-form__avatar", "aria-hidden": true, children: initialsFromName(props.patientName) }), _jsxs("div", { children: [_jsxs("h3", { className: "rx-form__context-name", children: [props.patientName || '—', props.patientCode ? (_jsxs("span", { className: "rx-form__context-code", children: [' ', "(", props.patientCode, ")"] })) : null] }), props.appointmentId != null && (_jsx("p", { className: "rx-form__context-meta", children: props.translate('prescriptions.form.visitMeta', {
                                            id: props.appointmentId
                                        }) }))] })] }), _jsx("span", { className: "rx-form__context-badge", children: props.translate('prescriptions.form.visitType') })] })), _jsx("div", { className: "rx-form__items", children: prescriptionItems.map(function (prescriptionItem, index) { return (_jsx(NewPrescriptionItem, { prescriptionItem: prescriptionItem, elementIdentifier: index, canRemove: prescriptionItems.length > 1, onRemove: function () { return removePrescriptionItem(index); }, onFieldsChange: onItemFieldsChange }, index)); }) }), _jsxs("button", { type: "button", className: "rx-form__add", onClick: addPrescriptionItem, children: [_jsx(PlusOutlined, {}), _jsx("span", { children: props.translate('prescriptions.form.addMedicine') })] }), error && _jsx("p", { className: "rx-form__error", children: error }), _jsxs("div", { className: "rx-form__footer", children: [_jsx("button", { type: "button", className: "rx-form__btn rx-form__btn--ghost", onClick: cancel, children: props.translate('common:buttons.cancel') }), _jsx("div", { className: "rx-form__footer-actions", children: _jsxs("button", { type: "submit", className: "rx-form__btn rx-form__btn--primary", children: [_jsx(CheckOutlined, {}), _jsx("span", { children: props.translate('prescriptions.form.save') })] }) })] })] }));
};
export default localeTranslator(NewPrescription, 'patientLog');
